// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2714":"1c4840d6","6681":"b3ee5e66","8098":"b3ee5e66","9807":"5f4ca8c0"}[chunkId] + ".chunk.css";
};